import { Link } from 'react-router'

export default function NotFound() {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-3 p-6">
      <p className="text-lg font-semibold">페이지를 찾을 수 없습니다</p>
      <Link to="/" className="text-sm text-primary underline">
        홈으로
      </Link>
    </main>
  )
}
